(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 13497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ AppShellProvider; },
/* harmony export */   "_": function() { return /* binding */ useAppShellContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);


const AppShellContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  zIndex: 1e3,
  fixed: false,
  layout: "default"
});
const AppShellProvider = AppShellContext.Provider;
function useAppShellContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AppShellContext);
}


//# sourceMappingURL=AppShell.context.js.map


/***/ }),

/***/ 34048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/utils/get-default-z-index/get-default-z-index.js
var get_default_z_index = __webpack_require__(847);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/utils/rem/rem.js
var rem = __webpack_require__(58349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/tss/Global.js
var Global = __webpack_require__(43351);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/AppShell/AppShell.context.js
var AppShell_context = __webpack_require__(13497);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(42112);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/AppShell/HorizontalSection/get-sorted-breakpoints/get-sorted-breakpoints.js
var get_sorted_breakpoints = __webpack_require__(82035);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/AppShell/VerticalSection/VerticalSection.styles.js



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var useStyles = (0,create_styles/* createStyles */.k)((theme, { height, fixed, position, zIndex, borderPosition, layout }) => {
  const breakpoints = typeof height === "object" && height !== null ? (0,get_sorted_breakpoints/* getSortedBreakpoints */.I)(height, theme).reduce((acc, [breakpoint, breakpointSize]) => {
    acc[`@media (min-width: ${(0,rem.em)(breakpoint)})`] = {
      height: (0,rem/* rem */.h)(breakpointSize),
      minHeight: (0,rem/* rem */.h)(breakpointSize)
    };
    return acc;
  }, {}) : null;
  return {
    root: __spreadProps(__spreadValues(__spreadProps(__spreadValues(__spreadValues({}, theme.fn.fontStyles()), position), {
      zIndex,
      left: layout === "alt" ? "var(--mantine-navbar-width, 0)" : 0,
      right: layout === "alt" ? "var(--mantine-aside-width, 0)" : 0,
      height: typeof height === "object" ? (0,rem/* rem */.h)(height == null ? void 0 : height.base) || "100%" : (0,rem/* rem */.h)(height),
      maxHeight: typeof height === "object" ? (0,rem/* rem */.h)(height == null ? void 0 : height.base) || "100%" : (0,rem/* rem */.h)(height),
      position: fixed ? "fixed" : "static",
      boxSizing: "border-box",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white
    }), breakpoints), {
      borderBottom: borderPosition === "bottom" ? `${(0,rem/* rem */.h)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2]}` : void 0,
      borderTop: borderPosition === "top" ? `${(0,rem/* rem */.h)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2]}` : void 0
    })
  };
});

/* harmony default export */ var VerticalSection_styles = (useStyles);
//# sourceMappingURL=VerticalSection.styles.js.map

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/AppShell/VerticalSection/VerticalSection.js







var VerticalSection_defProp = Object.defineProperty;
var VerticalSection_getOwnPropSymbols = Object.getOwnPropertySymbols;
var VerticalSection_hasOwnProp = Object.prototype.hasOwnProperty;
var VerticalSection_propIsEnum = Object.prototype.propertyIsEnumerable;
var VerticalSection_defNormalProp = (obj, key, value) => key in obj ? VerticalSection_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var VerticalSection_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (VerticalSection_hasOwnProp.call(b, prop))
      VerticalSection_defNormalProp(a, prop, b[prop]);
  if (VerticalSection_getOwnPropSymbols)
    for (var prop of VerticalSection_getOwnPropSymbols(b)) {
      if (VerticalSection_propIsEnum.call(b, prop))
        VerticalSection_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (VerticalSection_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && VerticalSection_getOwnPropSymbols)
    for (var prop of VerticalSection_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && VerticalSection_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const VerticalSection = (0,react.forwardRef)((_a, ref) => {
  var _b = _a, {
    children,
    className,
    classNames,
    styles,
    height,
    fixed = false,
    withBorder = true,
    position,
    zIndex,
    section,
    unstyled,
    __staticSelector,
    variant
  } = _b, others = __objRest(_b, [
    "children",
    "className",
    "classNames",
    "styles",
    "height",
    "fixed",
    "withBorder",
    "position",
    "zIndex",
    "section",
    "unstyled",
    "__staticSelector",
    "variant"
  ]);
  const ctx = (0,AppShell_context/* useAppShellContext */._)();
  const _zIndex = zIndex || ctx.zIndex || (0,get_default_z_index/* getDefaultZIndex */.w)("app");
  const { classes, cx, theme } = VerticalSection_styles({
    height,
    fixed: ctx.fixed || fixed,
    position,
    zIndex: typeof _zIndex === "number" && ctx.layout === "default" ? _zIndex + 1 : _zIndex,
    layout: ctx.layout,
    borderPosition: withBorder ? section === "header" ? "bottom" : "top" : "none"
  }, { name: __staticSelector, classNames, styles, unstyled, variant });
  const breakpoints = typeof height === "object" && height !== null ? (0,get_sorted_breakpoints/* getSortedBreakpoints */.I)(height, theme).reduce((acc, [breakpoint, breakpointSize]) => {
    acc[`@media (min-width: ${(0,rem.em)(breakpoint)})`] = {
      [`--mantine-${section}-height`]: (0,rem/* rem */.h)(breakpointSize)
    };
    return acc;
  }, {}) : null;
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, VerticalSection_spreadValues({
    component: section === "header" ? "header" : "footer",
    className: cx(classes.root, className),
    ref
  }, others), children, /* @__PURE__ */ react.createElement(Global/* Global */.x, {
    styles: () => ({
      ":root": VerticalSection_spreadValues({
        [`--mantine-${section}-height`]: typeof height === "object" ? (0,rem/* rem */.h)(height == null ? void 0 : height.base) || "100%" : (0,rem/* rem */.h)(height)
      }, breakpoints)
    })
  }));
});
VerticalSection.displayName = "@mantine/core/VerticalSection";


//# sourceMappingURL=VerticalSection.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/AppShell/Header/Header.js




var Header_defProp = Object.defineProperty;
var Header_defProps = Object.defineProperties;
var Header_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Header_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Header_hasOwnProp = Object.prototype.hasOwnProperty;
var Header_propIsEnum = Object.prototype.propertyIsEnumerable;
var Header_defNormalProp = (obj, key, value) => key in obj ? Header_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Header_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Header_hasOwnProp.call(b, prop))
      Header_defNormalProp(a, prop, b[prop]);
  if (Header_getOwnPropSymbols)
    for (var prop of Header_getOwnPropSymbols(b)) {
      if (Header_propIsEnum.call(b, prop))
        Header_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Header_spreadProps = (a, b) => Header_defProps(a, Header_getOwnPropDescs(b));
const defaultProps = {
  fixed: false,
  position: { top: 0, left: 0, right: 0 }
};
const Header = (0,react.forwardRef)((props, ref) => {
  const _props = (0,MantineProvider/* useComponentDefaultProps */.N4)("Header", defaultProps, props);
  return /* @__PURE__ */ react.createElement(VerticalSection, Header_spreadProps(Header_spreadValues({
    section: "header",
    __staticSelector: "Header"
  }, _props), {
    ref
  }));
});
Header.displayName = "@mantine/core/Header";


//# sourceMappingURL=Header.js.map


/***/ }),

/***/ 82035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getSortedBreakpoints; }
/* harmony export */ });
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30324);
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68659);


function getSortedBreakpoints(breakpoints, theme) {
  if (!breakpoints) {
    return [];
  }
  const values = Object.keys(breakpoints).filter((breakpoint) => breakpoint !== "base").map((breakpoint) => [
    (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_0__/* .getSize */ .a)({ size: breakpoint, sizes: theme.breakpoints, units: "em" }),
    breakpoints[breakpoint]
  ]);
  values.sort((a, b) => (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_1__/* .getBreakpointValue */ .oI)(a[0]) - (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_1__/* .getBreakpointValue */ .oI)(b[0]));
  return values;
}


//# sourceMappingURL=get-sorted-breakpoints.js.map


/***/ }),

/***/ 13337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ PasswordInput; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-id/use-id.js + 1 modules
var use_id = __webpack_require__(65208);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-uncontrolled/use-uncontrolled.js
var use_uncontrolled = __webpack_require__(34647);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/utils/rem/rem.js
var rem = __webpack_require__(58349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/utils/get-size/get-size.js
var get_size = __webpack_require__(30324);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/PasswordInput/PasswordToggleIcon.js


const PasswordToggleIcon = ({
  reveal,
  size
}) => /* @__PURE__ */ react.createElement("svg", {
  width: size,
  height: size,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ react.createElement("path", {
  d: reveal ? "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z" : "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd"
}));


//# sourceMappingURL=PasswordToggleIcon.js.map

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(42112);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Input/Input.styles.js
var Input_styles = __webpack_require__(41614);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/PasswordInput/PasswordInput.styles.js



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var useStyles = (0,create_styles/* createStyles */.k)((theme, { rightSectionWidth }, { size }) => ({
  visibilityToggle: {},
  input: {
    position: "relative",
    overflow: "hidden"
  },
  innerInput: __spreadProps(__spreadValues(__spreadValues({}, theme.fn.fontStyles()), theme.fn.cover(0)), {
    backgroundColor: "transparent",
    border: `${(0,rem/* rem */.h)(1)} solid transparent`,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    boxSizing: "border-box",
    display: "block",
    width: `calc(100% - ${(0,rem/* rem */.h)(rightSectionWidth)})`,
    paddingLeft: `calc(${(0,get_size/* getSize */.a)({ size, sizes: Input_styles/* sizes */.J })}  / 3)`,
    fontSize: (0,get_size/* getSize */.a)({ size, sizes: theme.fontSizes }),
    height: `calc(${(0,get_size/* getSize */.a)({ size, sizes: Input_styles/* sizes */.J })} - ${(0,rem/* rem */.h)(2)})`,
    lineHeight: `calc(${(0,get_size/* getSize */.a)({ size, sizes: Input_styles/* sizes */.J })} - ${(0,rem/* rem */.h)(4)})`,
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
    "&::-ms-reveal, &::-ms-clear": {
      display: "none"
    },
    "&:focus": {
      outline: 0
    },
    "&:disabled": {
      cursor: "not-allowed",
      pointerEvents: "none",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[1],
      color: theme.colors.dark[2],
      opacity: 0.6,
      "&::placeholder": {
        color: theme.colors.dark[2]
      }
    },
    "&::placeholder": __spreadProps(__spreadValues({}, theme.fn.placeholderStyles()), {
      opacity: 1
    }),
    "&[data-invalid]": {
      color: theme.fn.variant({ variant: "filled", color: "red" }).background,
      "&::placeholder": {
        opacity: 1,
        color: theme.fn.variant({ variant: "filled", color: "red" }).background
      }
    },
    "&[data-with-icon]": {
      paddingLeft: (0,get_size/* getSize */.a)({ size, sizes: Input_styles/* sizes */.J })
    }
  })
}));

/* harmony default export */ var PasswordInput_styles = (useStyles);
//# sourceMappingURL=PasswordInput.styles.js.map

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/style-system-props/extract-system-styles/extract-system-styles.js
var extract_system_styles = __webpack_require__(6733);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ActionIcon/ActionIcon.js + 1 modules
var ActionIcon = __webpack_require__(95202);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Input/Input.js + 11 modules
var Input = __webpack_require__(2000);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/PasswordInput/PasswordInput.js









var PasswordInput_defProp = Object.defineProperty;
var PasswordInput_defProps = Object.defineProperties;
var PasswordInput_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var PasswordInput_getOwnPropSymbols = Object.getOwnPropertySymbols;
var PasswordInput_hasOwnProp = Object.prototype.hasOwnProperty;
var PasswordInput_propIsEnum = Object.prototype.propertyIsEnumerable;
var PasswordInput_defNormalProp = (obj, key, value) => key in obj ? PasswordInput_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var PasswordInput_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (PasswordInput_hasOwnProp.call(b, prop))
      PasswordInput_defNormalProp(a, prop, b[prop]);
  if (PasswordInput_getOwnPropSymbols)
    for (var prop of PasswordInput_getOwnPropSymbols(b)) {
      if (PasswordInput_propIsEnum.call(b, prop))
        PasswordInput_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var PasswordInput_spreadProps = (a, b) => PasswordInput_defProps(a, PasswordInput_getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (PasswordInput_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && PasswordInput_getOwnPropSymbols)
    for (var prop of PasswordInput_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && PasswordInput_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const buttonSizes = {
  xs: (0,rem/* rem */.h)(22),
  sm: (0,rem/* rem */.h)(26),
  md: (0,rem/* rem */.h)(28),
  lg: (0,rem/* rem */.h)(32),
  xl: (0,rem/* rem */.h)(40)
};
const iconSizes = {
  xs: (0,rem/* rem */.h)(12),
  sm: (0,rem/* rem */.h)(15),
  md: (0,rem/* rem */.h)(17),
  lg: (0,rem/* rem */.h)(19),
  xl: (0,rem/* rem */.h)(21)
};
const rightSectionSizes = {
  xs: (0,rem/* rem */.h)(28),
  sm: (0,rem/* rem */.h)(32),
  md: (0,rem/* rem */.h)(34),
  lg: (0,rem/* rem */.h)(44),
  xl: (0,rem/* rem */.h)(54)
};
const defaultProps = {
  size: "sm",
  toggleTabIndex: -1,
  visibilityToggleIcon: PasswordToggleIcon,
  __staticSelector: "PasswordInput"
};
const PasswordInput = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("PasswordInput", defaultProps, props), {
    radius,
    disabled,
    size,
    toggleTabIndex,
    className,
    id,
    label,
    error,
    required,
    style,
    icon,
    description,
    wrapperProps,
    classNames,
    styles,
    variant,
    visibilityToggleIcon: VisibilityToggleIcon,
    __staticSelector,
    rightSection: _rightSection,
    rightSectionWidth: _rightSectionWidth,
    rightSectionProps: _rightSectionProps,
    sx,
    labelProps,
    descriptionProps,
    errorProps,
    unstyled,
    visibilityToggleLabel,
    withAsterisk,
    inputContainer,
    iconWidth,
    inputWrapperOrder,
    visible,
    defaultVisible,
    onVisibilityChange
  } = _a, others = __objRest(_a, [
    "radius",
    "disabled",
    "size",
    "toggleTabIndex",
    "className",
    "id",
    "label",
    "error",
    "required",
    "style",
    "icon",
    "description",
    "wrapperProps",
    "classNames",
    "styles",
    "variant",
    "visibilityToggleIcon",
    "__staticSelector",
    "rightSection",
    "rightSectionWidth",
    "rightSectionProps",
    "sx",
    "labelProps",
    "descriptionProps",
    "errorProps",
    "unstyled",
    "visibilityToggleLabel",
    "withAsterisk",
    "inputContainer",
    "iconWidth",
    "inputWrapperOrder",
    "visible",
    "defaultVisible",
    "onVisibilityChange"
  ]);
  const rightSectionWidth = (0,get_size/* getSize */.a)({ size, sizes: rightSectionSizes });
  const { classes } = PasswordInput_styles({ rightSectionWidth }, { name: "PasswordInput", classNames, styles, unstyled, size, variant });
  const uuid = (0,use_id/* useId */.M)(id);
  const { systemStyles, rest } = (0,extract_system_styles/* extractSystemStyles */.x)(others);
  const [_visible, setVisibility] = (0,use_uncontrolled/* useUncontrolled */.C)({
    value: visible,
    defaultValue: defaultVisible,
    finalValue: false,
    onChange: onVisibilityChange
  });
  const toggleVisibility = () => setVisibility(!_visible);
  const rightSection = /* @__PURE__ */ react.createElement(ActionIcon/* ActionIcon */.A, {
    className: classes.visibilityToggle,
    tabIndex: toggleTabIndex,
    radius,
    size: (0,get_size/* getSize */.a)({ size, sizes: buttonSizes }),
    "aria-hidden": !visibilityToggleLabel,
    "aria-label": visibilityToggleLabel,
    unstyled,
    onMouseDown: (event) => {
      event.preventDefault();
      toggleVisibility();
    },
    onKeyDown: (event) => {
      if (event.key === " ") {
        event.preventDefault();
        toggleVisibility();
      }
    }
  }, /* @__PURE__ */ react.createElement(VisibilityToggleIcon, {
    reveal: _visible,
    size: (0,get_size/* getSize */.a)({ size, sizes: iconSizes })
  }));
  return /* @__PURE__ */ react.createElement(Input/* Input.Wrapper */.I.Wrapper, PasswordInput_spreadValues(PasswordInput_spreadValues({
    required,
    id: uuid,
    label,
    error,
    description,
    size,
    className,
    style,
    classNames,
    styles,
    __staticSelector,
    sx,
    errorProps,
    descriptionProps,
    labelProps,
    unstyled,
    withAsterisk,
    inputWrapperOrder,
    inputContainer,
    variant
  }, systemStyles), wrapperProps), /* @__PURE__ */ react.createElement(Input/* Input */.I, {
    component: "div",
    error,
    icon,
    size,
    classNames: PasswordInput_spreadProps(PasswordInput_spreadValues({}, classNames), { input: classes.input }),
    styles,
    radius,
    disabled,
    __staticSelector,
    rightSectionWidth,
    rightSection: !disabled && rightSection,
    variant,
    unstyled,
    iconWidth
  }, /* @__PURE__ */ react.createElement("input", PasswordInput_spreadValues({
    type: _visible ? "text" : "password",
    required,
    "data-invalid": !!error || void 0,
    "data-with-icon": !!icon || void 0,
    className: classes.innerInput,
    disabled,
    id: uuid,
    ref
  }, rest))));
});
PasswordInput.displayName = "@mantine/core/PasswordInput";


//# sourceMappingURL=PasswordInput.js.map


/***/ }),

/***/ 43351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Global; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49175);
/* harmony import */ var _theme_MantineProvider_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69777);




function Global({ styles }) {
  const theme = (0,_theme_MantineProvider_js__WEBPACK_IMPORTED_MODULE_1__/* .useMantineTheme */ .rZ)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .Global */ .xB, {
    styles: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(typeof styles === "function" ? styles(theme) : styles)
  });
}


//# sourceMappingURL=Global.js.map


/***/ }),

/***/ 43953:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(32279);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);
/* harmony import */ var service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90309);
/* harmony import */ var utils_isServer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83845);



var useAccountSubscriptionCache = function() {
    var ref, ref1, ref2;
    var ref3 = (0,types_domain__WEBPACK_IMPORTED_MODULE_0__/* .useAccountSubscriptionQuery */ .fgK)({
        skip: !utils_isServer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && !service__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSystemToken */ .Z.getSystemToken()
    }), data = ref3.data, loading = ref3.loading;
    return {
        account: data === null || data === void 0 ? void 0 : data.account,
        subscription: data === null || data === void 0 ? void 0 : (ref = data.account) === null || ref === void 0 ? void 0 : ref.subscription,
        vasBalance: data === null || data === void 0 ? void 0 : (ref1 = data.account) === null || ref1 === void 0 ? void 0 : ref1.vasBalance,
        features: data === null || data === void 0 ? void 0 : (ref2 = data.account) === null || ref2 === void 0 ? void 0 : ref2.features,
        loading: loading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAccountSubscriptionCache);


/***/ }),

/***/ 90706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);
/* harmony import */ var modules_Login_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73194);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33892);



var useCachedIdentifier = function(form) {
    var mounted = (0,hooks__WEBPACK_IMPORTED_MODULE_1__/* .useMounted */ .s4)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (mounted) {
            var ref;
            form.setValues({
                identifier: (ref = sessionStorage.getItem(modules_Login_constants__WEBPACK_IMPORTED_MODULE_2__/* .LOGIN_IDENTIFIER */ .B)) !== null && ref !== void 0 ? ref : ""
            });
        }
    }, [
        mounted
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useCachedIdentifier);


/***/ }),

/***/ 45006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33021);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63332);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55075);




var XMDivider = function(props) {
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .useMantineTheme */ .rZ)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Divider */ .i, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_1__/* .getBorderColor */ .kJ)("gray.2", theme)
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (XMDivider);


/***/ }),

/***/ 17406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Im": function() { return /* binding */ XM_SITE_PENDING_APPLY_TPL_UNSUPPORTED_BANNER; },
/* harmony export */   "VM": function() { return /* binding */ XM_SITE_PENDING_PRODUCT_CODE; },
/* harmony export */   "hl": function() { return /* binding */ XM_SITE_PENDING_APPLY_TPL_CODE; }
/* harmony export */ });
var XM_SITE_PENDING_APPLY_TPL_CODE = "hx_site_pending_apply_template_code";
var XM_SITE_PENDING_APPLY_TPL_UNSUPPORTED_BANNER = "hx_site_pending_apply_template_unsupported_banner";
var XM_SITE_PENDING_PRODUCT_CODE = "hx_site_pending_product_code";


/***/ }),

/***/ 58586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Login_Form; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(17192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(29848);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.6.0/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(33481);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var next_router = __webpack_require__(73654);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/FocusTrap/FocusTrap.js + 4 modules
var FocusTrap = __webpack_require__(8487);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/TextInput/TextInput.js
var TextInput = __webpack_require__(79965);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/PasswordInput/PasswordInput.js + 2 modules
var PasswordInput = __webpack_require__(13337);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/use-form.js + 17 modules
var use_form = __webpack_require__(68329);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(65895);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js
var isNil = __webpack_require__(88966);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./src/components/ui/Geetest/index.tsx + 1 modules
var Geetest = __webpack_require__(12686);
// EXTERNAL MODULE: ./src/hooks/index.ts + 8 modules
var hooks = __webpack_require__(33892);
// EXTERNAL MODULE: ./src/utils/index.ts + 8 modules
var utils = __webpack_require__(73046);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var constants = __webpack_require__(95660);
// EXTERNAL MODULE: ./src/modules/Login/constants.ts
var Login_constants = __webpack_require__(73194);
;// CONCATENATED MODULE: ./src/modules/Login/hooks/useAutoFillButtonDisableState.ts

function useAutoFillButtonDisableState(mobile) {
    var identifierInputRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isAutoFill = ref[0], setIsAutoFill = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        (ref = identifierInputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
        setTimeout(function() {
            var isAutoFilled = document.querySelectorAll("input:-internal-autofill-selected").length > 0;
            if (isAutoFilled) {
                setIsAutoFill(true);
            }
        // 500: if too small，maybe invalid，so as big as possible
        }, 500);
    }, []);
    (0,react.useEffect)(function() {
        if (isAutoFill) {
            setIsAutoFill(false);
        }
    // eslint-disable-next-line
    }, [
        mobile
    ]);
    return {
        identifierInputRef: identifierInputRef,
        isAutoFill: isAutoFill
    };
}

// EXTERNAL MODULE: ./src/config/constants/sessionStorage.ts
var constants_sessionStorage = __webpack_require__(17406);
// EXTERNAL MODULE: ./src/modules/Login/actionsAfterLogin.ts
var actionsAfterLogin = __webpack_require__(94523);
// EXTERNAL MODULE: ./src/components/business/hooks/useCachedIdentifier.ts
var useCachedIdentifier = __webpack_require__(90706);
// EXTERNAL MODULE: ./src/plugins/apollo/index.tsx
var apollo = __webpack_require__(3745);
// EXTERNAL MODULE: ./src/utils/cookieUtils.ts
var cookieUtils = __webpack_require__(44259);
// EXTERNAL MODULE: ./src/config/constants/cookie.ts
var cookie = __webpack_require__(70211);
;// CONCATENATED MODULE: ./src/modules/Login/Form.tsx


























var Form = function(_param) {
    var validateIdentifier = function validateIdentifier(value) {
        if (!value) {
            return t("errors.identifierRequired");
        }
        if (!(0,utils/* isMobileOrEmail */.QG)(value.trim())) {
            return t("errors.identifierInvalid");
        }
        return null;
    };
    var validatePassword = function validatePassword(value) {
        if (!value) {
            return t("errors.passwordRequired");
        }
        return null;
    };
    var handleErrors = function handleErrors(graphQLErrors) {
        var graphQLError = graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors[0];
        var extensions = graphQLError === null || graphQLError === void 0 ? void 0 : graphQLError.extensions;
        var errorCode = extensions === null || extensions === void 0 ? void 0 : extensions.code;
        switch(errorCode){
            case "error.invalid_credentials":
                form.setFieldError("identifier", t("errors.invalidCredential"));
                break;
            case "error.not_registered":
                var identifier = formValuesRef.current.identifier;
                sessionStorage.setItem(Login_constants/* LOGIN_IDENTIFIER */.B, identifier);
                var signupLink = getSignupLink(identifier);
                var message = (0,utils/* isMobile */.tq)(identifier) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                    i18nKey: "errors.notRegistered",
                    components: {
                        component: signupLink
                    }
                }) : t("errors.emailNotfound");
                form.setFieldError("identifier", message);
                break;
            default:
                var isAppInviting = (invitation === null || invitation === void 0 ? void 0 : invitation.type) === domain/* MemberInvitationType.Application */.AVj.Application;
                var mapping = new Map();
                if (isAppInviting) {
                    mapping.set("error.mismatched", t("pageAppInvite:errors.accountMismatched"));
                }
                (0,utils/* graphqlErrorCatch */.Qf)({
                    graphQLErrors: graphQLErrors,
                    mapping: mapping,
                    defaultMessage: t(isAppInviting ? "pageAppInvite:errors.default" : "errors.default", {
                        message: graphQLError.message
                    })
                });
        }
    };
    var invitation = _param.invitation, getSignupLink = _param.getSignupLink, props = (0,_object_without_properties/* default */.Z)(_param, [
        "invitation",
        "getSignupLink"
    ]);
    var t = (0,useTranslation/* default */.Z)("pageLogin").t;
    var router = (0,next_router.useRouter)();
    var _identifier;
    var identifier = (_identifier = props.identifier) !== null && _identifier !== void 0 ? _identifier : "";
    var form = (0,use_form/* useForm */.c)({
        initialValues: {
            identifier: identifier,
            password: ""
        },
        validate: {
            identifier: validateIdentifier,
            password: validatePassword
        }
    });
    (0,useCachedIdentifier/* default */.Z)(form);
    var formValuesRef = (0,react.useRef)(form.values);
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useLoginMutation */.YAP)(), 1), loginMutation = ref[0];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,domain/* useGeetestConfigurationLazyQuery */.g_E)({
        fetchPolicy: "no-cache"
    }), 2), getGeetestConfiguration = ref2[0], geetestConfigurationRes = ref2[1];
    var ref3 = useAutoFillButtonDisableState(form.values.identifier), identifierInputRef = ref3.identifierInputRef, isAutoFill = ref3.isAutoFill;
    (0,react.useEffect)(function() {
        getGeetestConfiguration().then();
    // eslint-disable-next-line
    }, []);
    (0,react.useEffect)(function() {
        formValuesRef.current = form.values;
    }, [
        form.values
    ]);
    var handleLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(captcha) {
            var _current, identifier, password, data, ref, _signInUser, token, user, invitationAcceptance, loginPreRoute, ref1, newlyJoined, appInvitation, pendingApplyTplCode, pendingProductCode, appId, err, graphQLErrors;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _current = formValuesRef.current, identifier = _current.identifier, password = _current.password;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            14,
                            ,
                            15
                        ]);
                        return [
                            4,
                            loginMutation({
                                variables: {
                                    input: {
                                        principal: identifier.trim(),
                                        principalType: (0,utils/* isMobile */.tq)(identifier) ? domain/* PrincipalType.Mobile */.eZj.Mobile : domain/* PrincipalType.Email */.eZj.Email,
                                        credential: password,
                                        geetestInfo: captcha && (0,Geetest/* getGeetestResult */.o)(captcha),
                                        invitation: invitation
                                    }
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        if (!(data === null || data === void 0 ? void 0 : data.signInUser)) return [
                            3,
                            13
                        ];
                        _signInUser = data.signInUser, token = _signInUser.token, user = _signInUser.user, invitationAcceptance = _signInUser.invitationAcceptance;
                        (0,actionsAfterLogin/* initAndCleanUpLoginData */.d)(token, user === null || user === void 0 ? void 0 : user.id);
                        if (!!(user === null || user === void 0 ? void 0 : user.accountUser)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            router.replace(constants/* AccountComplete */.wx)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                    case 4:
                        loginPreRoute = (0,cookieUtils/* read */.ij)(cookie/* HX_LOGIN_PRE_ROUTE */.$8);
                        if (!!(0,isNil/* default */.Z)(loginPreRoute)) return [
                            3,
                            6
                        ];
                        (0,cookieUtils/* remove */.Od)({
                            name: cookie/* HX_LOGIN_PRE_ROUTE */.$8,
                            domain: ".howxm.com"
                        });
                        return [
                            4,
                            router.replace(loginPreRoute)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        ref1 = invitationAcceptance !== null && invitationAcceptance !== void 0 ? invitationAcceptance : {}, newlyJoined = ref1.newlyJoined, appInvitation = ref1.invitation;
                        pendingApplyTplCode = (0,cookieUtils/* read */.ij)(constants_sessionStorage/* XM_SITE_PENDING_APPLY_TPL_CODE */.hl);
                        pendingProductCode = (0,cookieUtils/* read */.ij)(constants_sessionStorage/* XM_SITE_PENDING_PRODUCT_CODE */.VM);
                        if (!(pendingApplyTplCode || pendingProductCode)) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            router.replace(constants/* ApplicationDefault */.HO)
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2
                        ];
                    case 8:
                        return [
                            4,
                            getApplicationAfterSignIn(appInvitation === null || appInvitation === void 0 ? void 0 : (ref = appInvitation.application) === null || ref === void 0 ? void 0 : ref.id)
                        ];
                    case 9:
                        appId = _state.sent();
                        if (!appId) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            router.replace({
                                pathname: constants/* ApplicationSurvey */.mf,
                                query: {
                                    appId: appId,
                                    newlyJoined: newlyJoined
                                }
                            }, constants/* ApplicationSurvey.replace */.mf.replace("[appId]", appId))
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            13
                        ];
                    case 11:
                        return [
                            4,
                            router.replace(constants/* AccountComplete */.wx)
                        ];
                    case 12:
                        _state.sent();
                        _state.label = 13;
                    case 13:
                        return [
                            3,
                            15
                        ];
                    case 14:
                        err = _state.sent();
                        graphQLErrors = err.graphQLErrors;
                        handleErrors(graphQLErrors);
                        setLoading(false);
                        return [
                            3,
                            15
                        ];
                    case 15:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLogin(captcha) {
            return _ref.apply(this, arguments);
        };
    }();
    var getApplicationAfterSignIn = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(invitationApplicationId) {
            var ref, ref1, defaultApplication;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(0,isNil/* default */.Z)(invitationApplicationId)) {
                            return [
                                2,
                                invitationApplicationId
                            ];
                        }
                        return [
                            4,
                            (0,apollo/* initializeApollo */["in"])().query({
                                query: domain/* DefaultApplicationDocument */.s66
                            })
                        ];
                    case 1:
                        ref1 = _state.sent(), defaultApplication = ref1.data;
                        return [
                            2,
                            defaultApplication === null || defaultApplication === void 0 ? void 0 : (ref = defaultApplication.defaultApplication) === null || ref === void 0 ? void 0 : ref.id
                        ];
                }
            });
        });
        return function getApplicationAfterSignIn(invitationApplicationId) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useGeetest */.ol)(handleLogin, geetestConfigurationRes), 2), captcha = ref4[0], captchaConfiguration = ref4[1];
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(captchaConfiguration === null || captchaConfiguration === void 0 ? void 0 : captchaConfiguration.enabled)) return [
                            3,
                            1
                        ];
                        captcha === null || captcha === void 0 ? void 0 : captcha.showBox();
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            handleLogin(null)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FocusTrap/* FocusTrap */.i, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: form.onSubmit(handleSubmit),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, (0,_object_spread/* default */.Z)({
                    size: "md",
                    placeholder: t("form.identifier"),
                    "data-autofocus": true,
                    autoComplete: "username",
                    ref: identifierInputRef
                }, form.getInputProps("identifier"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordInput/* PasswordInput */.W, (0,_object_spread/* default */.Z)({
                    size: "md",
                    placeholder: t("form.password"),
                    mt: "xl",
                    autoComplete: "current-password"
                }, form.getInputProps("password"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    size: "md",
                    type: "submit",
                    fullWidth: true,
                    mt: "xl",
                    loading: loading,
                    disabled: !form.isValid("identifier") && !isAutoFill,
                    children: t("form.submit")
                })
            ]
        })
    });
};
/* harmony default export */ var Login_Form = (Form);


/***/ }),

/***/ 94523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ initAndCleanUpLoginData; }
/* harmony export */ });
/* harmony import */ var service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90309);
/* harmony import */ var modules_Login_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73194);
/* harmony import */ var utils_cookieUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44259);



function initAndCleanUpLoginData(token, userId) {
    service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].setSystemToken */ .Z.setSystemToken(token);
    service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].setUid */ .Z.setUid(userId);
    sessionStorage.removeItem(modules_Login_constants__WEBPACK_IMPORTED_MODULE_2__/* .LOGIN_IDENTIFIER */ .B);
    (0,utils_cookieUtils__WEBPACK_IMPORTED_MODULE_1__/* .removeUserSourceTrackingCookies */ .jW)();
}


/***/ }),

/***/ 73194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LOGIN_IDENTIFIER; }
/* harmony export */ });
var LOGIN_IDENTIFIER = "hx_login_identifier";


/***/ }),

/***/ 32279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(13192);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(91004);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(73268);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(68711);
/* harmony import */ var modules_Login_Form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58586);
/* harmony import */ var components_site__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24613);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29718);
/* harmony import */ var config_constants_routerPath__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30482);
/* harmony import */ var next_translate_Trans__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65895);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95660);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33892);
/* harmony import */ var components_business_hooks_usePersistorClient__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99447);
/* harmony import */ var config_constants_localStorage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(12834);
/* harmony import */ var hooks_useApollo__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(37788);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89935);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_13__);















var Login = function(param) {
    var referer = param.referer;
    (0,hooks__WEBPACK_IMPORTED_MODULE_9__/* .useAccountSourceTrack */ .j3)(referer);
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("pageLogin").t;
    var client = (0,hooks_useApollo__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({});
    var clearCache = (0,components_business_hooks_usePersistorClient__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        client: client,
        key: config_constants_localStorage__WEBPACK_IMPORTED_MODULE_11__/* .XM_DATA */ .s9
    }).clearCache;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        clearCache();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var getSignupLink = function(identifier) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_5__/* .AnchorLink */ .PN, {
            href: config_constants_routerPath__WEBPACK_IMPORTED_MODULE_6__/* .Signup */ .Al
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Stack */ .K, {
            align: "center",
            justify: "space-between",
            className: "flex-1",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_15__/* .Center */ .M, {
                className: "h-full w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_5__/* .SessionPaper */ .vD, {
                    noBorder: true,
                    minHeight: 0,
                    height: "auto",
                    p: 40,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Stack */ .K, {
                        justify: "space-between",
                        spacing: "xl",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Title */ .D, {
                                order: 2,
                                mb: "sm",
                                children: t("welcome")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_Login_Form__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                getSignupLink: getSignupLink
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_17__/* .Group */ .Z, {
                                position: "apart",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_18__/* .Text */ .x, {
                                        size: "sm",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            i18nKey: "pageLogin:noAccount",
                                            components: {
                                                component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_5__/* .AnchorLink */ .PN, {
                                                    href: config_constants_routerPath__WEBPACK_IMPORTED_MODULE_6__/* .Signup */ .Al
                                                })
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_18__/* .Text */ .x, {
                                        size: "sm",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            i18nKey: "pageLogin:forgotPassword",
                                            components: {
                                                component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_5__/* .AnchorLink */ .PN, {
                                                    href: config_constants__WEBPACK_IMPORTED_MODULE_8__/* .PasswordReset */ .CV
                                                })
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
Login.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_site__WEBPACK_IMPORTED_MODULE_4__/* .SessionLayout */ .bY, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_13___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "登录 - 浩客HowXm官网 - 数字化系统必备的应用内调研、评价、通知工具，支持免费试用"
                })
            }),
            page
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Login);


/***/ }),

/***/ 25474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);
/* harmony import */ var howxm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13528);
/* harmony import */ var components_business_hooks_useCurrentUserCache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77759);
/* harmony import */ var components_business_hooks_useAccountSubscriptionCache__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19190);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73654);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);





var sdkHostMapping = {
    dev: "http://localhost:4000/umd",
    usd: "https://static-usd.howxm.com",
    cny: "https://static-cny.howxm.com",
    prod: "https://static.howxm.com"
};
var useHowxmSDK = function(appId) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), howxmSdkReady = ref[0], setHowxmSdkReady = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var subscription = (0,components_business_hooks_useAccountSubscriptionCache__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().subscription;
    var user = (0,components_business_hooks_useCurrentUserCache__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().user;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (appId && localStorage) {
            var sdkEnv = localStorage.getItem("sdkEnv") || "prod";
            var sdkUrl = "".concat(sdkHostMapping[sdkEnv], "/sdk.js");
            (0,howxm_js__WEBPACK_IMPORTED_MODULE_1__/* .initHowxmWithCustomSdkUrl */ ._e)(appId, sdkUrl, function() {
                setHowxmSdkReady(true);
            });
        }
    }, [
        appId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        identify(user);
    }, [
        user,
        router
    ]);
    var identify = function(user) {
        var ref;
        if (!howxmSdkReady || !user) {
            return;
        }
        var uid = user.id, email = user.email, name = user.name, mobile = user.mobile, accountUser = user.accountUser, createdAt = user.createdAt;
        var accountId = (accountUser === null || accountUser === void 0 ? void 0 : (ref = accountUser.account) === null || ref === void 0 ? void 0 : ref.id) || "";
        var ref1;
        (0,howxm_js__WEBPACK_IMPORTED_MODULE_1__/* .identifyHowxm */ .Lo)({
            uid: uid,
            email: email || "",
            name: name || "",
            mobile: mobile || "",
            account_id: accountId,
            registered_at: new Date(createdAt).toISOString(),
            subscription: (ref1 = subscription === null || subscription === void 0 ? void 0 : subscription.productCode) !== null && ref1 !== void 0 ? ref1 : "",
            banner_link: "".concat("https://app-cny.howxm.com", "/banner/accounts/").concat(accountId),
            last_seen_at: new Date().toISOString()
        });
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useHowxmSDK);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8329,4476,3226,9774,2888,179], function() { return __webpack_exec__(43953); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);